// Configurações centrais do site PlayMenu.
// Substitua os valores abaixo pelos dados reais de produção.

export const SITE_CONFIG = {
  // Número de WhatsApp (formato internacional, sem espaços ou símbolos).
  // Exemplo: "5511999999999". ATENÇÃO: substituir pelo número real.
  whatsappNumber: "5511999999999",
  whatsappMessage:
    "Olá, vim pelo site da PlayMenu e quero conhecer a plataforma.",
  instagramUrl: "https://instagram.com/playmenu.app",
  instagramHandle: "@playmenu.app",
  siteUrl: "https://playmenu.app/",
};

export function buildWhatsAppLink(): string {
  return `https://wa.me/${SITE_CONFIG.whatsappNumber}?text=${encodeURIComponent(
    SITE_CONFIG.whatsappMessage
  )}`;
}